<template>
  <div class="to-guild-leader-box">
    <top-header :text="$t('guild_transfer_to_leader')" :color="'#000'"></top-header>
    <div class="content-box">
      <div class="to-number">{{ $t('guild_transfer_pcoin_amount') }}</div>
      <div class="input-wrapper" @click="inputFocus">
        <!-- 图标 + 输入框整体居中 -->
        <img src="../../assets/withdrawal/coin.png" alt="coin" class="coin-icon" />
        <!-- 隐藏的测量元素 -->
        <span
        ref="measureRef"
        class="measure"
        aria-hidden="true"
        >{{ inputValue }}</span>
        <input
        ref="inputRef"
          v-model="inputValue"
          type="text"
          inputmode="decimal"
          placeholder=""
          class="center-input"
          @input="changeCoin"
          @click.stop="inputFocus"
          @blur="inputValue || (inputValue = 0)"
        />
      </div>
      <p class="tp-number-tips">{{ $t('guild_current_withdrawable_pcoin') }}<span>{{ cin.toLocaleString('en-US') }}</span></p>
      <ul class="gear-box">
        <li :class="gearType == 0 ? 'act-gear' : ''" @click="changeGearType(0)">{{ $t('guild_all') }}</li>
        <li :class="gearType == 1 ? 'act-gear' : ''" @click="changeGearType(1)">1/2</li>
        <li :class="gearType == 2 ? 'act-gear' : ''" @click="changeGearType(2)">1/3</li>
        <li :class="gearType == 3 ? 'act-gear' : ''" @click="changeGearType(3)">1/4</li>
      </ul>
      <div class="tips-box">
        <header>{{ $t('guild_read_before_withdraw') }}</header>
        <ul class="withrawal-tips">
            <li>
                {{ $t('guild_ci_hand') }}
                <span>{{$t('guild_offline_transfer_funds')}}</span>
            </li>
            <li>{{ $t('guild_ci_hand_2') }}</li>
            <li>{{ $t('guild_ci_hand_3',{n:this.applyMinNum}) }}</li>
            <li>{{ $t('guild_ci_hand_4') }}
                <span class="appeal-btn" @click="goPublish">{{ $t('guild_ci_hand_5') }}</span>
            </li>
        </ul>
      </div>
      <div class="submit-btn" @click="submitApply">{{ $t('guild_withdraw_note_1') }}</div>
    </div>
    <!-- 自定义弹窗 -->
    <div v-if="showPop" class="custom-popup-mask" @click="closePopup">
      <div class="custom-popup-content" @click.stop>
        <div class="safety-icon"></div>
        <p class="pop-title">{{ $t('guild_min_withdraw_amount') }}</p>
        <p class="pop-tips" v-html="$t('guild_ci_hand_6',{n:`<span>${inputValue} </span>`})">
        </p>
        <div class="pop-tips-content">
            <span class="pop-tips-content-icon"></span>
            {{ $t('guild_ci_hand_7') }}
        </div>
        <div class="popup-footer">
          <button class="btn-confirm" @click="confirm">{{ $t('guild_appeal_to_platform') }}</button>
          <button class="btn-cancel" @click="closePopup">{{ $t('guild_withdraw_note_4') }}</button>
        </div>
      </div>
    </div>
    <div class="loading-box" v-if="loading">
      <van-loading type="spinner" vertical />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Loading,Toast } from 'vant';
import topHeader from '@/components/withdrawal/top-header.vue';

export default {
  name: 'toguildleader',
  components: {
    topHeader,
    VanLoading: Loading
  },
  data() {
    return {
      loading: false,
      cin: '',
      inputWidth:'',
      inputValue:0,
      inputValue2:0,
    //   档位类型
      gearType:5,
      showPop:false,
    //   起提数
      applyMinNum:0,
      guildId:1109916,//公会ID
      guildUid:994846,//公会长uid
      coinNum:0,//提现P币数
      appealToPlatformUrl:'',//申诉页面
    };
  },
  created() {
    this.cin = Number(this.$route.query.cin) || 0;
    this.guildId = this.$route.query.guildId;
    this.guildUid = this.$route.query.guildUid;
    this.applyMinNum = this.$route.query.minCoin || 0;
    this.appealToPlatformUrl = this.$route.query.toUrl || '';
    this.getUserInfo();
  },
  methods:{
    inputFocus(){
        const input = this.$refs.inputRef;
        if(this.inputValue == 0){
          this.inputValue = '';
          this.placeholder = '';
        }
        this.$nextTick(() => {
          input.focus();
          const len = input.value.length;
          input.setSelectionRange(len, len);
        });
        this.changeGearType(5)
    },
    /**
     * 提交申请处理函数
     * 
     * @description 验证输入值是否满足最小申请数量要求，不满足则显示Toast提示，满足则显示申请弹窗
     * @returns {void} 无返回值，根据验证结果执行相应操作
     */
    submitApply(){
        if(Number(this.inputValue) > Number(this.cin)){
            return Toast(this.$t('guild_withdraw_note_2'));
        }
        if(Number(this.inputValue) < Number(this.applyMinNum)){
            return Toast(this.$t('guild_tips_1') + this.applyMinNum);
        }
        this.showPop = true;
    },
    goPublish(){
        window.open(this.appealToPlatformUrl + '?isShowNav=0&type=4&langType=' + this.lang + '&userId=' + this.uid)
    },
    closePopup() {
      this.showPop = false;
    },
    confirm() {
        if(this.loading) return; // 防连点
        let that = this
        this.loading = true;
        axios({
        url: that.$serviceIp + `api/trade/guild/withdraw/transferToLeader/apply`,
        method: "post",
          headers: {
            'version': '3.0',
            'deviceId': that.deviceId,
            'lang': that.lang,
          },
        data: {
          guildId: that.guildId,
          guildUid: that.guildUid,
          coinNum: that.inputValue
        },
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
            this.closePopup();
            Toast(this.$t('guild_communicate_with_reseller'));
            setTimeout(()=>{
                this.$router.go(-1);
            },500)
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 获取用户信息
    getUserInfo(){
      var ids = navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
      );
      if (ids) {
        ids = ids[0];
      } else {
        ids = "Unknown Device";
      }
      let data = JSON.parse(localStorage.getItem("data"));
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || ids;
       let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("guild_transfer_to_leader");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    // 修改档位
    changeGearType(type){
        if(this.gearType == type){
          this.gearType = 5;
          this.inputValue = 0;
        }else{
          this.gearType = type;
          if(type == 0){
              this.inputValue = this.cin;
          }else if(type == 1){
              this.inputValue = Math.floor(this.cin/2);
          }else if(type == 2){
              this.inputValue = Math.floor(this.cin/3);
          }else if(type == 3){
              this.inputValue = Math.floor(this.cin/4);
          }
        }
        this.changeCoin()
    },
    // 调整input宽度
    changeCoin(){
        // 只保留整数，去除0开头
        this.inputValue = this.inputValue.toString().replace(/[^\d]/g, '').replace(/^0+/, '') || '';
        this.$nextTick(() => {
            const span = this.$refs.measureRef;
            if (span) {
                // 获取内容宽度（包含 padding）
                const width = span.offsetWidth;
                // 设置最小宽度防止太窄
                this.inputWidth = width+20; // +20 是左右 padding
                if(this.inputValue.length > 5){
                    this.inputWidth = width+40;
                }
                if(this.inputValue.length > 9){
                    this.inputWidth = width+60;
                }
                if(this.inputValue.length > 13){
                    this.inputWidth = width+80;
                }
                // 应用到 input
                this.$refs.inputRef.style.width = this.inputWidth + 'px';
            }
        });
    }
  }
};
</script>

<style scoped>
body {
  background-color: #f5f6f8;
  font-family: 'Mada';
}
html[lang="ar"] .to-guild-leader-box{
  direction: rtl;
}
html[lang="ar"] .withrawal-tips li{
    padding-right: 1em;
    padding-left: 0;
}
html[lang="ar"] .tips-box header::before{
    margin-left: 16px;
    margin-right: 0;
}
.content-box {
  margin-top: 32px;
  padding: 0 48px;
  box-sizing: border-box;
  width: 100vw;
   font-family: 'Mada';
}

.to-number {
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  color: #1f1315;
  margin-bottom: 24px;
}

/* 关键：输入框容器 */
.input-wrapper {
  width: 100%;
  height: 88px;
  border: 1px solid #dbdbdb;
  border-radius: 24px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
  background: white;
  box-sizing: border-box;
  position: relative;
}

.coin-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0; /* 防止被压缩 */
}

.center-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 28px;
  text-align: center;
  width: 60px;
  min-width: 60px;
  padding: 0;
  line-height: 1;
}
/* 隐藏的测量元素 */
.measure {
  position: absolute;
  visibility: hidden;
  white-space: pre; /* 保留空格和换行 */
  font-size: 16px;
  font-family: "Mada", sans-serif;
  padding: 4px 10px;
  top: -9999px;
  left: -9999px;
}
.tp-number-tips{
    font-size: 28px;
    font-weight: 400;
    color: #262427;
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 16px 0;
}
.tp-number-tips span{
    display: flex;
    align-items: center;
    margin-left: 4px;
}
.tp-number-tips span::before{
    content: "";
    width: 36px;
    height: 36px;
    background: url("../../assets/withdrawal/coin.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: -4px;
}
.gear-box{
    display: flex;
    justify-content: space-between;
    padding-bottom: 48px;
    border-bottom: 1px solid #DBDBDB;
}
.gear-box li{
    width: 120px;
    height: 64px;
    border: 1px solid #DBDBDB;
    border-radius: 16px;
    font-size: 24px;
    line-height: 64px;
    color: #89848D;
    text-align: center;
    font-weight: 400;
}
.act-gear{
    color: #4D70FF!important;
    border-color: #4D70FF!important;
}
.tips-box{
    width: 544px;
    margin: 0 auto;
    margin-top: 48px;
    padding: 16px 24px;
    border-radius: 24px;
    box-sizing: border-box;
    background: linear-gradient(to bottom, rgba(255, 147, 147, 0.6),rgba(255, 147, 147, 0));
}
.tips-box header{
    font-size: 24px;
    color: #FF4365;
    font-weight: 500;
    display: flex;
    margin-bottom: 20px;
}
.tips-box header::before{
    content:'';
    width: 32px;
    line-height: 32px;
    background: url("../../assets/withdrawal/elert.png") no-repeat;
    background-size: 100%;
    margin-right: 16px;
}
.withrawal-tips li{
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    text-indent: -1em;
    padding-left: 1em;
    color: #262427;
}
.withrawal-tips li span{
    font-weight: 600;
}
.appeal-btn{
    color: #4682E9;
}
.submit-btn{
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 422px;
    height: 88px;
    text-align: center;
    border-radius: 44px;
    font-size: 28px;
    line-height: 88px;
    color: #fff;
    background-color: #4D70FF;
}

/* 遮罩层 */
.custom-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end; /* 从底部对齐 */
  align-items: flex-end;
  z-index: 2;
  animation: fadeIn 0.3s ease;
}

/* 弹窗内容 */
.custom-popup-content {
  width: 100%;
  /* height: 656px; */
  box-sizing: border-box;
  max-width: 100vw;
  background: linear-gradient(to bottom, #ECEBFF,#fff);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 48px;
  box-sizing: border-box;
  transform: translateY(100%);
  animation: slideIn 0.3s ease forwards;
  position: relative;
}

/* 动画：遮罩淡入 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 动画：内容从底部滑入 */
@keyframes slideIn {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* 关闭时的反向动画（可选，这里用 v-if 直接移除，所以不需要 out 动画） */
.popup-footer{
    text-align: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
}
.btn-cancel,
.btn-confirm {
  width: 422px;
  height: 88px;
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  border-radius: 44px;
    border: none;
}

.btn-cancel {
  background: #DBDBDB;
  color: #262427;
  margin-top: 24px;
}

.btn-confirm {
  background: #4D70FF;
  color: white;
}
.safety-icon{
    width: 266px;
    height: 266px;
    position: absolute;
    right: 0;
    top: -133px;
    background: url("../../assets/withdrawal/safety-icon.png") no-repeat;
    background-size: 100% 100%;
}
.pop-title{
    font-size: 28px;
    font-weight: 500;
    color: #1f1315;
}
.pop-tips{
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    color: #262427;
    margin-top: 24px;
}
.pop-tips span::before{
    display: inline-block;
    content: "";
    width: 30px;
    height: 30px;
    background: url("../../assets/withdrawal/coin.png") no-repeat;
    background-size: 100% 100%;
    vertical-align: middle;
}
.pop-tips >>> span::before,
.pop-tips /deep/ span::before,
.pop-tips ::v-deep span::before{
    display: inline-block;
    content: "";
    width: 30px;
    height: 30px;
    background: url("../../assets/withdrawal/coin.png") no-repeat;
    background-size: 100% 100%;
    vertical-align: middle;
}
.pop-tips-content{
    width: 544px;
    padding: 16px 24px 16px 72px;
    margin: 0 auto;
    box-sizing: border-box;
    font-size: 24px;
    line-height: 30px;
    border-radius: 24px;
    background: linear-gradient(to bottom, rgba(147, 183, 255, 0.5),rgba(147, 255, 212, 0));
    margin-top: 24px;
    position: relative;
    margin-bottom: 42px;
}
.pop-tips-content-icon{
    position: absolute;
    top: 16px;
    left: 24px;
    width: 32px;
    height: 32px;
    background: url("../../assets/withdrawal/ok.png") no-repeat;
    background-size: 100% 100%;
}

.loading-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
}
</style>